// extracted by mini-css-extract-plugin
export default {"slider":"CustomSlider_slider__0oyhJ","slick-next":"CustomSlider_slick-next__4clxS"};